/**
 * Shared layout class strings for analytics pages.
 * Mobile (< md): 2 cards per row
 * Tablet (md–lg): existing multi-column layouts
 * Desktop (lg+): unchanged
 */

export const analyticsStatsGrid4Class = 'grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4';
export const analyticsStatsGrid3Class = 'grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4';
export const analyticsStatsGrid2Class = 'grid grid-cols-2 lg:grid-cols-2 gap-3 sm:gap-4';
export const analyticsStatsGrid6Class = 'grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3 sm:gap-4';
export const analyticsStatsGrid8Class = 'grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-3 sm:gap-4';
export const analyticsCardGridClass = 'grid grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-3 sm:gap-4';
export const analyticsTopGridClass = 'grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4';
export const analyticsPaymentModesGridClass = 'grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4';
export const analyticsChargesGridClass = 'grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4';

export const analyticsSectionClass = 'bg-white rounded-xl shadow-md p-3 sm:p-4 lg:p-6';

export const analyticsMetricCardClass =
  'bg-white rounded-xl shadow-md p-3 sm:p-4 lg:p-6 hover:shadow-lg transition-shadow min-w-0';

export const analyticsCompactMetricCardClass =
  'bg-white rounded-xl shadow-sm border border-gray-200 p-3 sm:p-4 lg:p-6 min-w-0';

/** Shared light-blue icon chip for all analytics cards. */
export const analyticsIconChipClass = 'bg-blue-50 text-blue-600 border-blue-200';

/** Soft pastel icon chip classes — unified to light blue. */
export const analyticsSoft = {
  blue: analyticsIconChipClass,
  indigo: analyticsIconChipClass,
  sky: analyticsIconChipClass,
  cyan: analyticsIconChipClass,
  teal: analyticsIconChipClass,
  emerald: analyticsIconChipClass,
  green: analyticsIconChipClass,
  amber: analyticsIconChipClass,
  yellow: analyticsIconChipClass,
  orange: analyticsIconChipClass,
  rose: analyticsIconChipClass,
  red: analyticsIconChipClass,
  purple: analyticsIconChipClass,
  violet: analyticsIconChipClass,
};

export const analyticsSoftBtn =
  'px-4 py-2 bg-sky-50 text-sky-700 border border-sky-200 rounded-xl hover:bg-sky-100 transition-colors text-sm font-medium';
